<template>
<div id="imger">
  <div class="logoBar">
      <h1></h1>
      <a href="http://www.jsdnn.com/" target="_blank">狄诺尼官网</a>
  </div>
  <div>
    <el-form :model="forgetForm" :rules="rules2" ref="forgetForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
      <h2 class="title">密码重置</h2>
      <el-form-item prop="phone">
          <span class="iconfont icon-dianhua"></span>
          <el-input class="phone" type="text" v-model="forgetForm.phone" auto-complete="off" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item   prop= "smsCode" >
          <span class="iconfont icon-securityCode-b"></span>
          <el-input  type = "text" v-model= "forgetForm.smsCode" placeholder="验证码" class = "phone form-control" ></el-input>
          <el-button type="button" class="el_reg" @click="smsCode" :disabled="disabled" v-if="disabled==false">发送验证码
          </el-button>
          <el-button type="button" class="el_reg" @click="smsCode" :disabled="disabled" v-if="disabled==true">{{btntxt}}
          </el-button>
      </el-form-item> 
      
      <el-form-item prop="password">
          <span class="iconfont icon-mima"></span>
          <el-input class="phone" type="password" v-model="forgetForm.password" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>

      <el-form-item prop="conpassword">
          <span class="iconfont icon-querenmima"></span>
          <el-input class="phone" type="password" v-model="forgetForm.conpassword" auto-complete="off" placeholder="确认密码"></el-input>
      </el-form-item>

      <slide-verify @success="onSuccess" @fail="onFail" @refresh="onRefresh" :slider-text="texts"></slide-verify>
      <div style="height:20px;width:100%"></div>
      <el-form-item style="width:100%;margin-bottom:0px">
        <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">提交</el-button>
      </el-form-item>
      
      
    </el-form>
  </div>
  <div class="ftBox">
      <p>江苏狄诺尼信息技术有限责任公司</p>
      <p>CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906</p>
  </div>
</div>
</template>

<script>

  import axios from 'axios'
  import { API__code, API__login } from '../api/index.js'
  import { requestLogin } from '../api/api';
  export default {
    data() {
      return {
        msg: '',
        texts: '滑动验证',
        disabled: false,
        time: 0,
        btntxt: "重新发送",
        radio: 3,
        logining: false,
        forgetForm: {
          phone: '',
          password: '',
          conpassword:'',
          smsCode: '',//验证码
        },
        rules2: {
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
          conpassword: [
            { required: true, message: '请确认密码', trigger: 'blur' },
            { required: true, message: '密码至少8位', trigger: ['blur', 'change'],min:8 },
          ],
          smsCode: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            { required: true, message: '请输入6位验证码', trigger: ['blur', 'change'],len:6 }
          ],
          
        },
        checked: true
      };
    },
    mounted() {
        
    },
    methods: {
      
      onSuccess(){
          this.msg = 'success';
      },
      onFail(){
          this.msg = ''
      },
      onRefresh(){
          this.msg = ''
      },
      //发送验证码
      smsCode() {
          if(this.msg !="success"){
            this.$message.error('请拖到图片进行验证！');
            return;
          }
          // const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
          const reg = /^1[3-9]\d{9}$/
          if (this.forgetForm.phone == '') {
              this.$message({
                  message:'手机号不能为空',
                  center: true
              })
              return
          }
          if (!reg.test(this.forgetForm.phone)) {
              this.$message({
                  message:'请输入正确的手机号',
                  center:true
              })
              return
          } else {
             // console.log(this.forgetForm.phone);
              let para = {
                  phone: this.forgetForm.phone
              };
              API__login.sendSmsCode(para)
              .then((res) =>{
                
                  if(res.data.code == API__code.SUCCESS ){
                      this.$message({
                          message: '发送成功',
                          type: 'success',
                          center:true
                      });
                      this.time = 60;
                      this.disabled = true;
                      this.timer();
                  }else{
                      this.$message.error(res.data.message);
                  }
              }).catch(err =>{
                    this.$message.error('服务器异常，请您稍后再试..');
                    this.pageLoading = false;
              });
          }
      },
      //60S倒计时
      timer() {
          if (this.time > 0) {
              this.time--;
              this.btntxt = this.time + "s后重新获取";
              setTimeout(this.timer, 1000);
          } else {
              this.time = 0;
              this.btntxt = "获取验证码";
              this.disabled = false;
          }
      },

      handleSubmit2(formName) {
        
        this.$refs.forgetForm.validate((valid) => {
          if (valid) {
            this.forget();
          } else {
            this.$message.error('请正确输入登录账号和密码..');
            return false;
          }
        });
      },
      // 重置密码
      forget() {
        this.pageLoading = true;
        let param ={
          password:this.forgetForm.password,
          phone:this.forgetForm.phone,
          // userType:'',//用户类型
          smsCode:this.forgetForm.smsCode,
          conpassword:this.forgetForm.conpassword,
        }
        // console.log(API__login.login);
        API__login.forget(param)
        .then( (res) => {
          if( res.data.code == API__code.SUCCESS ) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.$router.push({path: 'login'});
          }else {
            this.$message.error(res.data.message);
          }
          this.pageLoading = false;
        }).catch( e => {
          this.$message.error('服务器异常，请您稍后再试..');
          this.pageLoading = false;
        });
      },
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    
    width: 350px;
    padding: 35px 50px 35px 50px;
    background: rgba(0,0,0,0.4);
   // opacity: 0.5;
    //border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #214976;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #fff;
      text-align: center;
      // margin-top: 20px;
      // margin-bottom: 20px;
      color: rgb(255, 255, 255);
      text-shadow: rgb(0, 0, 0) 0px 2px 4px;
      font-size: 20px;
      font-weight: normal;
    }
    .remember {
      margin: 0px 0px 35px 0px;
      color:#fff;
    }
  }
  
  #imger{    
      width: 100%;
      height: 100%;
      background:  url('./img/loginBg.jpg');
      background-size: cover;
      // position: fixed;
      // z-index: -10;
    }
  .logoBar {
    background: rgba(0,0,0,.3);
    height: 60px;
    width: 100%;
    position: absolute;
    z-index: 2;
}
.logoBar h1 {
    margin-top: 8px;
    margin-left: 20px;
    background: url(./img/logo.png) no-repeat;
    background-size: 100%;
    width: 140px;
    height: 43px;
    float: left;
}
.logoBar a {
    float: right;
    color: #fff;
    margin-top: 20px;
    font-size: 14px;
    margin-right: 20px;
    border-bottom: 0.55px solid #666;
    padding-bottom: 1px;
}
.ftBox {
    width: 100%;
    height: 60px;
    padding-top: 10px;
    background: rgba(0,0,0,.5);
    text-align: center;
    font-size: 13px;
    color: #fff;
    margin:0;
    display: block;
    position:absolute;
    left:0;
    bottom:0;
}
.ftBox p {
    margin: 0;
}
div {
    display: block;
}
.zhcss {
  padding-bottom: 20px;
  color:#fff;
}
.el-radio {
  color:#fff
}
.tips {
    float: right;
    margin: 30px 0 0 0;
}
.tips a {
    color: rgb(204, 204, 204);
    margin-left: 20px;
    cursor: pointer;
}
.el_reg{
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    background: #ecf5ff;
    color: #3a8ee6;
    border-radius: 0 4px 4px 0;
    border-color: #c6e2ff;
    border-left-color: #3a8ee6;
    &:hover{
        background: #c8e2ff;
    }
}
</style>


// WEBPACK FOOTER //
// Forget.vue?7e7e195f